import React from "react";

// reactstrap components
import {

  Container

} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";


function TerminosCondiciones() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>                     
            <h3 className="title text-center" style={{fontFamily: "'Noto Sans SC', sans-serif"}}>
              Términos y condiciones
            </h3>
            <center className="mt-5">
              <a
                href="#condiciones-uso"
                role="button"
                style={{textDecoration: "none !important", cursor: "pointer"}}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/condiciones-uso.json",
                    "Condiciones-Uso.pdf"
                  );
                }}
              >
                <img
                alt="Imagen con referencia Terminos"
                width="80px"
                src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Términos y condiciones</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default TerminosCondiciones;
